import posthog from "posthog-js";

type RouterLike = {
  subscribe: (listener: (state: { matches: Array<{ route: { path?: string } }> }) => void) => () => void;
};

/**
 * Registers the matched route *pattern* (e.g. "/accounts/:id") as a super
 * property so insights group by route rather than by concrete URL. Raw paths
 * here carry ids and tokens, which makes them useless as a grouping key.
 *
 * Note: this reflects the route as of the last completed navigation, so the
 * `$pageview` for a brand-new route can carry the previous route_name. Custom
 * funnel events, which fire after the route has settled, are unaffected.
 */
export const trackRouteChanges = (router: RouterLike): (() => void) => {
  if (!posthog.__loaded) return () => undefined;

  return router.subscribe((state) => {
    try {
      const matched = state.matches[state.matches.length - 1]?.route?.path;
      posthog.register({ route_name: matched ?? "unknown" });
    } catch {
      // Analytics must never break navigation.
    }
  });
};
